import { Action } from '@ngrx/store';
import { CardInterface } from '../../models/card.interface';

export enum ECardsActions {
  GetCards = '[CARDS] Get cards',
  GetCardsSuccess = '[CARDS] Get cards success',
  GetCardsFailure = '[CARDS] Get cards failure',
  DeleteCard = '[DELETE_CARD] Delete card failure',
  DeleteCardSuccess = '[DELETE_CARD] Delete card success',
  DeleteCardFailure = '[DELETE_CARD] Delete card failure',
}

/**
 * Set get cards action and state to save in store
 */
export class GetCards implements Action {
  public readonly type = ECardsActions.GetCards;
}

/**
 * Set get cards success action and state to save in store
 */
export class GetCardsSuccess implements Action {
  public readonly type = ECardsActions.GetCardsSuccess;
  // payload : request http to save in store, will be saved by the reducer
  constructor(public payload: Array<CardInterface>) {}
}

/**
 * Set get cards failure action and state to save in store
 */
export class GetCardsFailure implements Action {
  public readonly type = ECardsActions.GetCardsFailure;
}

export class DeleteCard implements Action {
  public readonly type = ECardsActions.DeleteCard;
  constructor(public paymentMethodId: string, public password: string) {}
}

export class DeleteCardFailure implements Action {
  public readonly type = ECardsActions.DeleteCardFailure;
}

export class DeleteCardSuccess implements Action {
  public readonly type = ECardsActions.DeleteCardSuccess;
  constructor(public paymentMethodId: string) {}
}

/**
 * Export actions : will be used in reducers
 */
export type CardsActions = GetCards | GetCardsSuccess | GetCardsFailure | DeleteCard | DeleteCardSuccess | DeleteCardFailure;
